<template>
  <section class="section" id="step-3">
    <CarEquipmentList :car-equipments="this.carEquipments" />

  </section>

</template>
<script>
import CarEquipmentList from "@/src/components/advertisement/CarEquipmentList.vue";
import ApiService from '../../../services/apiService.js';
export default {
  name: 'CarEquipmentStep',

  components: {
    CarEquipmentList,
  },

  data() {
    return {
      carEquipments: [],
    };
  },

  async mounted() {
    const { data } = await ApiService.get('car_equipments')
    this.carEquipments = data.carEquipments
  }
}
</script>
<style scoped>

</style>